module.exports = __webpack_public_path__ + "static/media/10.4167c95f.png";